var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLessThanL
    ? _c(
        "div",
        { staticClass: "gfu-featured-projects" },
        _vm._l(4, function (n) {
          return _c("skeleton-card", { key: n })
        }),
        1
      )
    : _c("skeleton-card", { staticClass: "gfu-featured-projects" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }